module.exports = __webpack_public_path__ + "assets/img/emergencyContact2.c33473e3.png";